import React from "react";
import { motion } from "framer-motion";

const services = [
  {
    id: 1,
    title: "Architectural Design",
    image: "/luxeheights2.jpg",
    description:
      "Our aim is to sit alongside the very best of global design. We want to create a positive architectural legacy with all our projects turning out to be a local or national landmark. With effective space planning, our projects have a cohesive sense of form and function that makes them attractive and usable for our clients. Our experience in planning and design is both deep and broad, with an extensive portfolio in the residential, lifestyle, multi-family, resort and other commercial fields.",
  },
  {
    id: 2,
    title: "Building & Construction",
    image: "/construction.jpg",
    description:
      "High-quality construction with attention to detail, durability, and premium finishes. Comprehensive building solutions with high-quality materials and expert craftsmanship.",
  },
  {
    id: 3,
    title: "Interior Design",
    image: "/interior.jpg",
    description:
      "We provide first-class interior design service for all our projects.Our expert design team sourced some exclusive collections to bring a new timeless aesthetic to design and we’ve picked up more than our fair share of recognition from developers, homeowners and other industry players.",
  },
  {
    id: 4,
    title: "Smart Homes",
    image: "/thehavern.jpg",
    description:
      "Integrating modern technology to make your living spaces smarter, safer, and more efficient.",
  },
  {
    id: 5,
    title: "Consulting",
    image: "/harven-1.jpg",
    description:
      "Expert advice and professional guidance to bring clarity and confidence to your projects.",
  },
//   {
//     id: 6,
//     title: "Building & Construction",
//     image: "/luxeheights2.jpg",
//     description:
//       "Comprehensive building solutions with high-quality materials and expert craftsmanship.",
//   },
];

export default function ServicesPage() {
  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section
        className="relative h-[60vh] bg-cover bg-center flex items-center justify-center"
        style={{ backgroundImage: "url('/luxeheights.jpg')" }}
      >
        <div className="absolute inset-0 bg-black/50" />
        <motion.div
          className="relative z-10 text-center text-white px-6"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-4xl md:text-5xl font-extrabold mb-4">
            Our Services
          </h1>
          <p className="text-lg max-w-2xl mx-auto">
            Explore Aspen Plush Homes’ premium services — designed with luxury,
            innovation, and precision.
          </p>
        </motion.div>
      </section>

      {/* Services Grid */}
      <div className="max-w-7xl mx-auto py-16 px-6 grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {services.map((s) => (
          <motion.div
            key={s.id}
            className="relative w-full h-80 cursor-pointer [perspective:1000px]"
            whileHover="hover"
          >
            <motion.div
              className="relative w-full h-full transition-transform duration-700 [transform-style:preserve-3d]"
              variants={{ hover: { rotateY: 180 } }}
            >
              {/* Front */}
              <div
                className="absolute inset-0 flex items-center justify-center rounded-2xl overflow-hidden [backface-visibility:hidden]"
                style={{
                  backgroundImage: `url(${s.image})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <div className="absolute inset-0 bg-black/40" />
                <h3 className="relative z-10 text-xl font-semibold text-white px-4 text-center">
                  {s.title}
                </h3>
              </div>

              {/* Back */}
              <div className="absolute inset-0 bg-white text-gray-700 p-6 flex items-center justify-center text-center rounded-2xl [transform:rotateY(180deg)] [backface-visibility:hidden]">
                <p className="text-sm">{s.description}</p>
              </div>
            </motion.div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
